var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"serve"}},[_c('iframe',{attrs:{"src":_vm.serveSrc},on:{"load":_vm.onIframeLoad}})])
}
var staticRenderFns = []

export { render, staticRenderFns }